import type { ActionCodeSettings, User } from "firebase/auth";

export const EMAIL_VERIFICATION_REQUIRED_MESSAGE =
  "Please verify your email before logging in. We sent a new verification link to your inbox.";

/**
 * Continue URL after Firebase's hosted /__/auth/action page verifies the address.
 * Do not use *.firebaseapp.com — that is the Auth domain, not the product.
 * The origin must be on Firebase Auth authorized domains.
 */
export function emailVerificationActionSettings(): ActionCodeSettings {
  const origin = (
    (typeof window !== "undefined" ? window.location.origin : "") ||
    String(import.meta.env.VITE_FRONTEND_BASE_URL || "")
  ).replace(/\/$/, "");

  return {
    url: `${origin}/login`,
    handleCodeInApp: false,
  };
}

export function requiresEmailVerification(user: User | null): boolean {
  if (!user) return false;
  const usesPasswordProvider =
    user.providerData.length === 0 ||
    user.providerData.some((provider) => provider.providerId === "password");
  return usesPasswordProvider && !user.emailVerified;
}

export function verificationErrorMessage(error: unknown, fallback: string): string {
  return error instanceof Error && error.message === EMAIL_VERIFICATION_REQUIRED_MESSAGE
    ? error.message
    : fallback;
}
